export const searchUserDefault = {
  name: '',
  login: '',
  followersUrl: '',
  followingUrl: '',
  avatarUrl: '',
  followersNum: 0,
  followingNum: 0,
  dataCreated: new Date(),
  company: '',
  email: '',
  reposNum: 0,
  reposUrl: '',
  location: '',
  lastActivityDate: '',
};

export const mobileWidth = 480;

export const defaultSearchUsersList = {
  total_count: null,
  incomplete_results: false,
  items: [],
};

export const usersPerPage = 10;
export const reposPerPage = 30;
